import "./Footer.css";

import React from "react";

import { Link } from "react-router-dom";

import SectionEightIcon from "../imageAssets/logo.png";

import TwitterIcon from "@mui/icons-material/Twitter";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import GoogleIcon from "@mui/icons-material/Google";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import MailIcon from "@mui/icons-material/Mail";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import CopyrightIcon from "@mui/icons-material/Copyright";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";

export const Footer = () => {
  const handleMoveToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="section-eight-contaienr">
      {/* <div className="section-eight-subsection1">
        <div>
          <p className="section-eight-subsection1-p1">Subscribe</p>
          <p className="section-eight-subsection1-p2">Weekly newsletter</p>
        </div>
        <input
          className="section-eight-subsection1-input"
          placeholder="Your email address"
        ></input>
        <button className="section-eight-subsection1-button">Subscribe</button>
        <div className="section-eight-subsection1-social-icons-container">
          <div className="section-eight-subsection1-icon-tweeter">
            <TwitterIcon
              className="section-eight-subsection1-icon-actual"
              sx={{ transition: " all 0.4s", color: "rgb(41, 41, 41)" }}
            />
          </div>
          <div className="section-eight-subsection1-icon-facebook">
            <FacebookIcon
              className="section-eight-subsection1-icon-actual"
              sx={{ transition: " all 0.4s", color: "rgb(41, 41, 41)" }}
            />
          </div>
          <div className="section-eight-subsection1-icon-instagram">
            <InstagramIcon
              className="section-eight-subsection1-icon-actual"
              sx={{ transition: " all 0.4s", color: "rgb(41, 41, 41)" }}
            />
          </div>
          <div className="section-eight-subsection1-icon-goooglePlus">
            <GoogleIcon
              className="section-eight-subsection1-icon-actual"
              sx={{ transition: " all 0.4s", color: "rgb(41, 41, 41)" }}
            />
            <p className="section-eight-subsection1-plus-icon">+</p>
          </div>
        </div>
      </div> */}
      <div className="section-eight-subsection-two-container">
        <div className="section-eight-subsection-two">
          <div className="section-eight-subsection-two-part1">
            <img
              className="section-eight-subsection-two-part-logo"
              src={SectionEightIcon}
            ></img>
          </div>
          <div className="section-eight-subsection-two-part2">
            <p className="section-eight-subsection-two-part2-p">Навигация</p>
            <div className="section-eight-subsection-two-part2-redirect-list">
              <Link
                onClick={handleMoveToTop}
                to={"/"}
                className="section-eight-subsection-two-part2-redirect-list-p"
              >
                <ArrowForwardIosIcon
                  sx={{ fontSize: "12px", mr: "3px", color: "#c0aa83" }}
                />
                Начало
              </Link>
              {/* <Link
                onClick={handleMoveToTop}
                to={"/"}
                className="section-eight-subsection-two-part2-redirect-list-p"
              >
                <ArrowForwardIosIcon
                  sx={{ fontSize: "12px", mr: "3px", color: "#c0aa83" }}
                />
                Blog
              </Link> */}

              <Link
                onClick={handleMoveToTop}
                to={"/about-us"}
                className="section-eight-subsection-two-part2-redirect-list-p"
              >
                <ArrowForwardIosIcon
                  sx={{ fontSize: "12px", mr: "3px", color: "#c0aa83" }}
                />
                За нас
              </Link>
              <Link
                onClick={handleMoveToTop}
                to={"/shop"}
                className="section-eight-subsection-two-part2-redirect-list-p"
              >
                <ArrowForwardIosIcon
                  sx={{ fontSize: "12px", mr: "3px", color: "#c0aa83" }}
                />
                Каталог
              </Link>
              <Link
                onClick={handleMoveToTop}
                to={"/gallery"}
                className="section-eight-subsection-two-part2-redirect-list-p"
              >
                <ArrowForwardIosIcon
                  sx={{ fontSize: "12px", mr: "3px", color: "#c0aa83" }}
                />
                Галерия
              </Link>
            </div>
          </div>
          <div className="section-eight-subsection-two-part3">
            <p className="section-eight-subsection-two-part3-p1">Магазин</p>
            <div className="section-eight-subsection-two-part3-p2">
              <LocationOnIcon
                sx={{ fontSize: "18px", mr: "5px", color: "#c0aa83" }}
              />
              град Варна, улица Русе 11
              {/* <a
                className="footer-mapLink1"
                href="https://www.google.com/maps/place/ul.+%22Ruse%22+11,+9000+Varna+Center,+Varna/@43.2032918,27.9116424,17z/data=!3m1!4b1!4m5!3m4!1s0x40a453f48a13d637:0x76c3ad1813f7a982!8m2!3d43.2032918!4d27.9116424"
              >
                Google Maps
              </a> */}
              <iframe
                style={{
                  width: "5rem",
                  height: "5rem",
                  marginLeft: "0.5rem",
                  borderRadius: "50%",
                }}
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d727.0738543217741!2d27.911095229207593!3d43.20329277626683!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40a453f48a13d637%3A0x76c3ad1813f7a982!2sul.%20%22Ruse%22%2011%2C%209000%20Varna%20Center%2C%20Varna!5e0!3m2!1sen!2sbg!4v1654547176261!5m2!1sen!2sbg"
                height="45"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
            <p className="section-eight-subsection-two-part3-shop-p">
              Работно време:
            </p>
            <p className="section-eight-subsection-two-part3-shop-p">
              Понеделник до Петък
            </p>
            <p className="section-eight-subsection-two-part3-shop-p">
              от 10:00 до 18:00 ч.
            </p>
            <p className="section-eight-subsection-two-part3-shop-p">
              Събота: от 10:00 до 14:00 ч.
            </p>
            <p className="section-eight-subsection-two-part3-shop-p">
              Почивка: от 12:00 до 13:00 ч.
            </p>
            <p className="section-eight-subsection-two-part3-contacts-p">
              Контакти
            </p>
            <p className="section-eight-subsection-two-part3-p2">
              <PhoneIcon
                sx={{ fontSize: "18px", mr: "15px", color: "#c0aa83" }}
              />
              088 460 5563
            </p>

            <a
              href="https://www.facebook.com/viktorio01/?ref=page_internal"
              className="section-eight-subsection-two-part3-p3"
            >
              <FacebookIcon
                sx={{ fontSize: "18px", mr: "15px", color: "#c0aa83" }}
              />
              New.football_boots
            </a>

            <a
              href="https://www.instagram.com/new.football_boots/?hl=en"
              className="section-eight-subsection-two-part3-p3"
            >
              <InstagramIcon
                sx={{ fontSize: "18px", mr: "15px", color: "#c0aa83" }}
              />
              new.football_boots
            </a>
          </div>
        </div>
        <div className="section-eight-footer">
          <p className="section-eight-footer-p">
            <a className="section-eight-footer-p-a" href="#">
              New football boots
            </a>
            <CopyrightIcon
              sx={{ fontSize: "14px", mr: "2px", ml: "2px", color: "#c0aa83" }}
            />
            All Rights Reserved.
          </p>
          <div onClick={handleMoveToTop} className="section-eight-arrow">
            <ArrowUpwardIcon sx={{ fontSize: "20px" }} />
          </div>
        </div>
      </div>
    </div>
  );
};
